import { proxy } from "valtio";
import { AppState } from "../types";

export const AppStore = proxy<AppState>({
  type: "website",
  portfolioChartVisabled: undefined,
});
